<div class="modal-header border-0 py-0">
    <h4 class="modal-title">{{ 'Service Request List' | translate }}</h4>
    <div class="ml-auto d-flex align-items-center">
        <app-discrepancy-switch></app-discrepancy-switch>
        <button class="close ml-3" type="button" aria-label="Close" (click)="activeModal.close(false)">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</div>
<div class="row mt-3">
    <div class="col">
        <ng-template #template let-anchor>
            <span>{{ anchor.nativeElement.innerText }}</span>
        </ng-template>
        <div
            kendoTooltip
            showOn="none"
            filter=".k-grid td"
            [tooltipTemplate]="template"
            (mouseover)="showTooltip($event)">
            <kendo-grid
                class="mb-2"
                [loading]="isBusy"
                [data]="itemsGridView"
                [skip]="itemPage.skip"
                [pageSize]="itemPage.pageSize"
                [pageable]="pagingOptions"
                [sortable]="{ allowUnsort: allowUnsort, mode: multiple ? 'multiple' : 'single' }"
                [sort]="sort"
                [resizable]="true"
                (pageChange)="pageChange($event, serviceRequests)"
                (sortChange)="sortChange($event, serviceRequests)">
                <kendo-grid-column title="{{ 'Number' | translate }}" field="number" [width]="100">
                    <ng-template kendoGridCellTemplate let-row>
                        @if (!hasPermission('TosOperations.ServiceRequest.Search')) {
                            <span>
                                {{ row.number }}
                            </span>
                        }
                        @if (hasPermission('TosOperations.ServiceRequest.Search')) {
                            <a class="row-link" (click)="navigateToServiceRequest(row.number)">
                                {{ row.number }}
                            </a>
                        }
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="{{ 'Type' | translate }}" field="type" [width]="100"></kendo-grid-column>
                <kendo-grid-column
                    title="{{ 'Manipulation' | translate }}"
                    field="manipulation"
                    [width]="100"></kendo-grid-column>
                <kendo-grid-column title="{{ 'Status' | translate }}" field="status.id" [width]="80">
                    <ng-template kendoGridCellTemplate let-row>
                        <div class="row pill-padding">
                            <span class="pill" [ngClass]="getClass(row.status.id)">
                                {{ row.status.localizedCode }}
                            </span>
                        </div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column
                    title="{{ 'TOS Number' | translate }}"
                    field="tosNumber"
                    [width]="130"></kendo-grid-column>
                <kendo-grid-column title="{{ 'Created Date' | translate }}" field="createdDate" [width]="130">
                    <ng-template kendoGridCellTemplate let-row>
                        {{ row.createdDate | date: 'dd.MM.yyyy' }}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="{{ 'Completed Date' | translate }}" field="completedDate" [width]="130">
                    <ng-template kendoGridCellTemplate let-row>
                        {{ row.completedDate | date: 'dd.MM.yyyy' }}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column
                    title="{{ 'Customer' | translate }}"
                    field="customer"
                    [width]="150"></kendo-grid-column>
                <kendo-grid-column
                    title="{{ 'Quantity' | translate }}"
                    field="numberOfUnits"
                    [width]="150"
                    [style]="{ 'text-align': 'right' }">
                    <ng-template kendoGridCellTemplate let-row>
                        <app-discrepancy-value
                            [realizedValue]="row.realizedNumberOfUnits"
                            [plannedValue]="row.numberOfUnits"
                            [canSeeRealized]="row.canSeeRealized"></app-discrepancy-value>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column
                    title="{{ 'Net Weight (kg)' | translate }}"
                    field="netWeight"
                    [width]="150"
                    [style]="{ 'text-align': 'right' }">
                    <ng-template kendoGridCellTemplate let-row>
                        <app-discrepancy-value
                            [realizedValue]="row.realizedNetWeight"
                            [plannedValue]="row.netWeight"
                            [canSeeRealized]="row.canSeeRealized"
                            [decimalPlaces]="3"></app-discrepancy-value>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column
                    title="{{ 'Gross Weight (kg)' | translate }}"
                    field="grossWeight"
                    [width]="150"
                    [style]="{ 'text-align': 'right' }">
                    <ng-template kendoGridCellTemplate let-row>
                        <app-discrepancy-value
                            [realizedValue]="row.realizedGrossWeight"
                            [plannedValue]="row.grossWeight"
                            [canSeeRealized]="row.canSeeRealized"
                            [decimalPlaces]="3"></app-discrepancy-value>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column
                    title="{{ 'Volume' | translate }}"
                    field="volume"
                    [width]="100"
                    [style]="{ 'text-align': 'right' }">
                    <ng-template kendoGridCellTemplate let-row>
                        <app-discrepancy-value
                            [realizedValue]="row.realizedVolume"
                            [plannedValue]="row.volume"
                            [canSeeRealized]="row.canSeeRealized"
                            [decimalPlaces]="3"></app-discrepancy-value>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column
                    title="{{ 'Terminal' | translate }}"
                    field="terminal"
                    [width]="120"></kendo-grid-column>
                <kendo-grid-column
                    title="{{ 'Terminal Operator' | translate }}"
                    field="terminalOperator"
                    [width]="120"></kendo-grid-column>
                <ng-template kendoGridNoRecordsTemplate>
                    <p>{{ 'No records available' | translate }}.</p>
                </ng-template>
            </kendo-grid>
        </div>
    </div>
</div>

<div class="modal-footer border-0 pb-0">
    <button class="btn btn-sm btn-secondary" translate (click)="activeModal.close(false)">Close</button>
</div>
